<template>
  <div>
    <v-layout v-if="loading" justify-center column fill-height style="min-height: 300px">
      <div class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="45"
          width="3"
        ></v-progress-circular>
      </div>
    </v-layout>
    <template v-else>
      <v-container>
        <v-layout>
          <v-flex>
            <h2>{{ $t('Beacon message') }}</h2>
          </v-flex>
        </v-layout>

        <v-layout v-if="intents.length > 1">
          <v-flex xs12 sm6 class="form-control">
            <input
              type="text"
              v-model.lazy="search"
              class="form-control"
              :placeholder="$t('Search Beacon message')"
              style="margin-bottom: 10px"
            />
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn outline color="primary" @click="expandAll">
              <i class="fas fa-expand-arrows-alt mr-1"></i>
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn outline color="primary" @click="collapseAll">
              <i class="fas fa-compress mr-1"></i>
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <div>
          <div style="margin-bottom: 10px;">
            <a href="javascript:void(0);" v-if="!isShow" @click="addCommentToInbox">
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('Add Beacon message') }}
              </div>
            </a>

            <div class="intent-item z-border-red" v-else style="padding: 10px 15px 0px;">
              <manage-intent
                :isCommentToInbox="false"
                :isBeacon="true"
                v-model="intent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
              ></manage-intent>
            </div>
          </div>

          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              :total-visible="15"
              v-model="pageNumber"
              :length="pageCount"
            ></v-pagination>
          </div>

          <intent-item
            :isLivechat="true"
            v-for="(item, index) in paginateIntent"
            v-model="paginateIntent[index]"
            :filterIntents="paginateIntent"
            :isCommentToInbox="false"
            :key="'intent_' + item.id + '_' + index"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            :excludedIntentName="excludedIntentName"
            @onUpdate="onUpdateIntent"
            :isBeacon="true"
          ></intent-item>

          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              :total-visible="15"
              v-model="pageNumber"
              :length="pageCount"
            ></v-pagination>
          </div>
        </div>
      </v-container>

      <div class="mt-5 mb-5"></div>
    </template>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from '@/components/view/intent/TransferIntent'
import { mapGetters } from 'vuex'
import manageIntent from '@/components/view/intent/intent-manage'
import intentItem from '@/components/view/intent/intent-item'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'
export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    ModalDialog,
    ModalHelp,
    TransferIntent
  },
  data() {
    return {
      loading: false,
      isShow: false,
      showModal: false,
      showPagination: false,
      pageNumber: 1,
      showsize: 50,

      intent: {
        campaign_name: '',
        q_type: 'text',
        a_type: 'json',
        q_val: 'exacts(beacon_enter)',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        status: true
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_comment_to_inbox: undefined,
      max_intent: 300
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    paginateIntent() {
      if (this.filterIntents.length >= this.showsize) {
        this.showPagination = true
        var start = (this.pageNumber - 1) * this.showsize
        var end = this.pageNumber * this.showsize
        var result = this.filterIntents.slice(start, end)
        return result
      } else {
        this.showPagination = false
        return this.filterIntents
      }
    },
    pageCount: function() {
      let l = this.filterIntents.length
      let s = this.showsize
      return Math.ceil(l / s)
    },
    filterIntents: function() {
      var vm = this
      if (!vm.intents) return []
      var intents = vm.intents
      if (this.filterContext) {
        intents = intents.filter(el => {
          return el.context_in == this.filterContext
        })
      }

      intents.sort(function(a, b) {
        var nameA = a.campaign_name.toUpperCase() // ignore upper and lowercase
        var nameB = b.campaign_name.toUpperCase() // ignore upper and lowercase
        if (a.campaign_name[0] == '{' && a.campaign_name[a.campaign_name.length - 1] == '}') {
          return 1
        }
        if (b.campaign_name[0] == '{' && b.campaign_name[b.campaign_name.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })

      var filteredIntent = intents.filter(intent => {
        var isFound =
          ((intent.campaign_name &&
            intent.campaign_name.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.q_val && intent.q_val.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_in &&
              intent.context_in.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.context_out &&
              intent.context_out.toLowerCase().includes(vm.search.toLowerCase())) ||
            (intent.a_val && intent.a_val.toLowerCase().includes(vm.search.toLowerCase()))) &&
          !['comment', 'facebooklive'].includes(intent.context_in)
        return isFound
      })

      filteredIntent = filteredIntent.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      )

      filteredIntent = filteredIntent.sort((x, y) =>
        x.status === y.status ? 0 : x.status ? -1 : 1
      )
      return filteredIntent
    },
    excludedIntentName: function() {
      var result = []
      var vm = this
      if (vm.allIntents) {
        vm.allIntents.map(function(intent, index) {
          result.push(intent.campaign_name)
        })
      }
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter(el => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.campaign_name
        )
      })
      return intentwithoutwelcome.length
    }
  },
  mounted: function() {
    var vm = this
    if (this.selectedBot.pageid == '176922345693076') {
      this.max_intent = 500
    }

    let package_config = this.getPackageConfig()
    this.max_intent = package_config.reply_comment

    vm.loading = true
    vm.getWelcomeMessage(function() {
      vm.getIntent(function() {
        vm.loading = false
      })
    })
    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function(payload) {
      var vm = this
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      // vm.allIntents.push(payload)
      vm.intent = {
        campaign_name: '',
        q_type: 'text',
        a_type: 'json',
        q_val: 'exacts(beacon_enter)',
        a_val: [[]],
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        status: true
      }
      vm.lastedIntentName = payload.campaign_name
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.campaign_name.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
    },
    copyIntent: function(payload) {
      console.log(payload)
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then(result => {
          result.isShow = true
          this.intents.push(result)
          // this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.campaign_name.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function(payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
    },
    getIntent: function(callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntentBecon(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response) {
          var intents = response.map(function(val) {
            var intent = { ...val }
            intent.isShow = false
            intent.ableToDelete = true
            return intent
          })
          vm.allIntents = intents
          vm.intents = intents

          var default_comment_to_inbox = intents.find(el => {
            return el.campaign_name == '{default_comment_to_inbox}'
          })

          if (default_comment_to_inbox) {
            default_comment_to_inbox.ableToDelete = false
            vm.default_comment_to_inbox = default_comment_to_inbox
          } else {
            vm.default_comment_to_inbox = {
              campaign_name: '{default_comment_to_inbox}',
              q_type: 'text',
              a_type: 'json',
              q_val: 'exacts(beacon_enter)',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false,
              pageidlist: '',
              userstatus: '',
              usertags: '',
              linenoti_status: false,
              linenoti_spec_ids: null,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              status: true
            }
          }
        }
        callback()
      })
    },
    deleteIntent: function(index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.paginateIntent[index].campaign_name.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let data = {
              id: vm.paginateIntent[index].id,
              pageid: vm.selectedBot.pageid
            }
            vm.$store.dispatch('loading')

            api.deleteIntentBecon(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              $.each(vm.intents, function(intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })

              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function(el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    addCommentToInbox() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t('Please contact us')}</b>`,
            confirmButtonText: this.$t('contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    getWelcomeMessage: function(callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function(index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies !== '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    expandAll: function() {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', true)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', true)
    },
    collapseAll: function() {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', false)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', false)
    },
    onUpdateIntent: function(payload) {
      var vm = this
      $.each(vm.intents, function(index, intent) {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      // this.getIntent(function() {})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/view/beacon/Messages.vue